import React from "react"
import styles from "./songgriditem.module.scss"


interface Props {
  onClick?: () => void
  playing: boolean
  numPlays: number
  title: string
  songArtworkUrl: string
  pinned?: boolean
  disabled?: boolean
}

const SongGridItem = (props: Props) => {
  let playButton = <></>;
  if (!props.disabled) {
    const classes = [styles.playButton].concat(props.playing ? [styles.playing] : [])
    playButton = <button className={classes.join(' ')} />
  }
  return (
    <div className={styles.songItemWrapper}
        style={{
            background: `no-repeat center/cover url(${props.songArtworkUrl})`,
            cursor: props.disabled ? 'default' : 'pointer'
        }}
        onClick={props.onClick}
    >
        <div className={styles.pinIcon} hidden={!props.pinned}>
            <img src={require("../../resources/pin.svg").default} alt="pinned" />
        </div>
        <div className={styles.metadataWrapper}>
            <div>▶ {props.numPlays}</div>
            <div>{props.title}</div>
        </div>
        {playButton}
        <div className={styles.disabledBlur} hidden={!props.disabled} />
        <div className={styles.disabledLock} hidden={!props.disabled} />
    </div>
  )
}

export default SongGridItem
